import { useState, useEffect, useCallback } from "react";
import { CustomerData } from "../types/payment";
import api from "../../../../../../features/auth/axiosConfig";
import { errorHandling } from "src/shared/utils/errorHandling";

export const useCustomerData = (customerId: string, autoFetch: boolean = true) => {
  const [customer, setCustomer] = useState<CustomerData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomerData = useCallback(async () => {
    if (!customerId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/pos/ledger/customer/${customerId}`);
      setCustomer(response.data.ledger);
    } catch (err: any) {
      console.error("Error fetching customer data:", err);
      errorHandling(err);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  useEffect(() => {
    if (autoFetch && customerId) {
      fetchCustomerData();
    }
  }, [customerId, autoFetch, fetchCustomerData]);

  return { customer, loading, error, refetch: fetchCustomerData };
};
